<template>
  <v-container fluid class="systemsetting-edit mt-3 mx-1">
    <v-row>
      <v-col cols="12" centered>
        <v-tabs
          color="primary"
        >
          <v-tabs-slider></v-tabs-slider>
          <v-tab
            :href="`#tab-systemsetting`"
            class="mr-5"
          >
            <v-icon class="mr-3">mdi-drawing-box</v-icon>
            Settings
          </v-tab>
          <v-tab
            class="mr-5"
            :href="`#tab-lists`"
          >
            <v-icon class="mr-3">mdi-playlist-check</v-icon>
            Lists
          </v-tab>
          <v-tab-item
            :value="'tab-systemsetting'"
          >
            <v-card
              elevation="0"
              flat
              tile
            >
              <v-card-text>
                <v-row justify="center">
                  <v-col cols="12" md="6">
                    <v-form>
                      <p class="text-h5">Edit Setting</p>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="updateChangedValue($event, 'settingcode')"
                        v-bind:value="initvalue.settingcode"
                        placeholder="Setting Code"
                        persistent-hint
                        single-line hint="Enter the setting code">
                      </v-text-field>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="updateChangedValue($event, 'settingname')"
                        v-bind:value="initvalue.settingname"
                        placeholder="Setting Name"
                        persistent-hint
                        single-line hint="Enter the setting name">
                      </v-text-field>
                      <v-select
                        class="mb-4"
                        :items=settingtype
                        :value="initvalue.settingtype"
                        outlined
                        dense
                        v-on:change="updateChangedValue($event, 'settingtype')"
                        placeholder="Type"
                        persistent-hint
                        single-line hint="Please choose the setting type">
                      </v-select>
                      <v-switch
                          color="primary"
                          v-on:change="updateChangedValue($event, 'settingstatus')"
                          v-bind:label="initvalue.settingstatus"
                          v-model="initvalue.settingstatus"
                          value="Active"
                      ></v-switch>
                      <div class="d-flex justify-center">
                        <v-btn
                            to="/systemsetting/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="editSystemSetting()">
                            Save
                          </v-btn>
                      </div>
                    </v-form>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item :value="'tab-lists'">
            <v-card elevation="0" flat tile>
              <v-card-text>
                <v-row justify="center">
                  <v-col cols="12" md="12">
                    <v-row>
                      <v-col md="11">
                        <p class="text-h5">Setting Lists</p>
                      </v-col>
                      <v-col md="1">
                        <v-btn
                          class="button-shadow"
                          color="secondary"
                          @click="showListDialog = true"
                        >
                          Add
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-form>
                      <v-data-table
                        :headers="listHeaders"
                        :items="systemsettinglists"
                        :items-per-page="100"
                        class="elevation-0"
                      >
                        <template v-slot:top>
                          <v-dialog v-model="deleteListDialog" width="500">
                            <v-card>
                              <v-card-title> Delete this List? </v-card-title>
                              <v-card-text>
                                {{ deletelist.settingname }}
                              </v-card-text>
                              <v-divider></v-divider>
                              <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                  color="primary"
                                  outlined
                                  @click="deleteListDialog = false"
                                  >Cancel</v-btn
                                >
                                <v-btn
                                  color="secondary"
                                  class="button-shadow"
                                  @click="deleteSystemSettingList(deletelist)"
                                  >Delete
                                </v-btn>
                              </v-card-actions>
                            </v-card>
                          </v-dialog>
                        </template>                    
                        <template v-slot:item.createdAt="{ item }">
                          {{
                            new Date(item.createdAt).toLocaleString("en-SG", {
                              year: "numeric",
                              month: "numeric",
                              day: "numeric",
                            })
                          }}
                        </template>
                        <template v-slot:item.actions="{ item }">
                          <v-btn
                            icon
                            color="primary"
                            @click="editSystemSettingListSheet(item)"
                          >
                            <v-icon>mdi-pencil</v-icon>
                          </v-btn>
                          <v-btn
                            icon
                            color="primary"
                            @click="deleteSystemSettingListDialog(item)"
                          >
                            <v-icon>mdi-close</v-icon>
                          </v-btn>
                        </template>
                      </v-data-table>
                    </v-form>
                  </v-col>
                </v-row>
                <v-row justify="center">
                  <v-col cols="12" md="12">
                    <div class="d-flex justify-center">
                      <v-btn
                        to="/systemsetting/list"
                        replace
                        outlined
                        color="primary"
                      >
                        Done
                      </v-btn>
                      <v-spacer></v-spacer>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs>
      </v-col>
    </v-row>
    <v-row justify="center">
    <v-dialog
      v-model="showListDialog"
      persistent
      width="800px"
      max-width="800px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Add Setting</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" md="2">
                <v-text-field
                  v-model="list.settingrank"
                  class="mb-4"
                  placeholder="Num"
                  type="number"
                  oninput="if(this.value < 0) this.value = 0;"
                  single-line
                  hint="Num"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field
                  v-model="list.settingname"
                  label="Name"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="7">
                <v-text-field
                  v-model="list.settingvalue"
                  label="Value"
                  required
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="showListDialog = false"
          >
            Close
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="addSystemSettingList"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
  <v-row>
      <v-bottom-sheet scrollable v-model="showListSheet" inset>
        <v-sheet class="text-center" height="250px" style="overflow-x: hidden;">
          <v-btn class="mt-6" text color="error" @click="showListSheet = !showListSheet">
            close
          </v-btn>
          <v-row justify="center">
              <v-col cols="12" md="1">
                <v-text-field
                  v-on:change="updateChangedList($event, 'settingrank')"
                  :value="editlist.settingrank"
                  class="mb-4"
                  placeholder="Num"
                  type="number"
                  oninput="if(this.value < 0) this.value = 0;"
                  single-line
                  hint="Num"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field
                  v-on:change="updateChangedList($event, 'settingname')"
                  v-model="editlist.settingname"
                  label="Text"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="3">
                <v-textarea
                  v-on:change="updateChangedList($event, 'settingvalue')"
                  v-model="editlist.settingvalue"
                  rows="2"
                  label="Value"
                  hint="Enter the setting value"
                  required
                ></v-textarea>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  v-on:change="updateChangedList($event, 'textinfo')"
                  v-model="editlist.textinfo"
                  label="Info"
                  required
                ></v-text-field>
              </v-col>
          </v-row>
          <v-row justify="center">
              <v-col cols="12" md="11">
                 <v-btn
            class="button-shadow"
            color="warning"
            @click="editSystemSettingList()"
          >
            Edit
          </v-btn>
              </v-col>
          </v-row>
         
        </v-sheet>
      </v-bottom-sheet>
      <v-bottom-sheet scrollable v-model="showImageSheet" inset>
        <v-sheet class="text-center" height="350px" style="overflow-x: hidden;">
          <v-btn class="mt-6" text color="error" @click="showImageSheet = !showImageSheet">
            close
          </v-btn>
          <v-row justify="center">
              <v-col cols="12" md="1">
                <v-text-field
                  v-on:change="updateChangedImage($event, 'imagerank')"
                  :value="editimage.imagerank"
                  class="mb-4"
                  placeholder="Num"
                  type="number"
                  oninput="if(this.value < 1) this.value = 1;"
                  single-line
                  hint="Num"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="9">
                <v-text-field
                  v-on:change="updateChangedImage($event, 'imagename')"
                  :value="editimage.imagename"
                  label="Name"
                  required
                ></v-text-field>
              </v-col>
          </v-row>
          <v-row justify="center">
            <v-col cols="12" md="5">
              <v-file-input outlined dense label="File input" v-model="imagefile" v-on:change="onImageFileChange" accept="image/*" />     
            </v-col>
            <v-col cols="12" md="5">
              <v-text-field
                outlined
                dense
                v-on:change="updateChangedImage($event, 'imageinfo')"
                :value="editimage.imageinfo"
                label="Info"
                required
              ></v-text-field>
            </v-col>
          </v-row>
           <v-row justify="center">
              <v-col cols="12" md="11">
                 <v-btn
            class="button-shadow"
            color="warning"
            @click="editSystemSettingImage()"
          >
            Edit
          </v-btn>
              </v-col>
           </v-row>
         
        </v-sheet>
      </v-bottom-sheet>
  </v-row>
  </v-container>
</template>

<script>
import {mapActions, mapState} from "vuex";
import router from '@/Routes';

export default {
  data () {
    return {
      imageHeaders: [
        { text: "#", value: "imagerank", width: "10px" },
        { text: "Image", value: "imageurl", width: "10%"},
        { text: "Name", value: "imagename" , width: "65%"},
        { text: "Created", value: "createdAt", width: "10%" },
        { text: "Actions", value: "actions", sortable: false , width: "10%"},
      ],
      listHeaders: [
        { text: "#", value: "settingrank", width: "10px" },
        { text: "Name", value: "settingname" },
        { text: "Value", value: "settingvalue" },
        { text: "Created", value: "createdAt", width: "10%" },
        { text: "Actions", value: "actions", sortable: false , width: "10%"},
      ],
      systemsetting: {},
      systemsettinglists: [],
      systemsettingimages: [],
      initvalue: {},
      settingtype: ['Boolean', 'Dynamic', 'Number', 'String'],
      error: undefined,
      haserror: false,
      errorindex: undefined,
      list: {},
      editlist: {},
      deletelist: {},
      deleteListDialog: false,
      showListDialog: false,
      showListSheet: false,
      image: {},
      imagefile: null,
      editimage: {},
      deleteimage: {},
      deleteImageDialog: false,
      showImageDialog: false,
      showImageSheet: false,
    }
  },
  methods: {
    ...mapActions('SystemSetting', [
      'getSystemSettingsRequest',
      'deleteSystemSettingImageRequest', 'deleteSystemSettingListRequest',
      'insertSystemSettingListRequest', 'insertSystemSettingImageRequest',
      'updateSystemSettingRequest','updateSystemSettingImageRequest','updateSystemSettingListRequest',
    ]),
    async addSystemSettingList() {
      this.showListDialog = false;
      this.list.systemsettingid = this.initvalue._id;
      let result = await this.insertSystemSettingListRequest(this.list);
      this.systemsettinglists.push(result);
      this.list = {};
    },
    async addSystemSettingImage() {
      this.showImageDialog = false;
      this.image.systemsettingid = this.initvalue._id;
      let result = await this.insertSystemSettingImageRequest(this.image);
      this.systemsettingimages.push(result);
      this.image = {};
    },
    deleteSystemSettingListDialog(item) {
      this.deleteListDialog = true;
      this.deletelist = {
        _id: item._id,
        settingname: item.settingname,
      };
    },
    deleteSystemSettingImageDialog(item) {
      this.deleteImageDialog = true;
      this.deleteimage = {
        _id: item._id,
        imagename: item.imagename,
      };
    },
    async deleteSystemSettingList(payload) {
      this.deleteListDialog = false;
      let response = await this.deleteSystemSettingListRequest(payload);
      let index = this.systemsettinglists.findIndex((trans) => trans._id == response._id);
      this.systemsettinglists.splice(index, 1);
    },
    async deleteSystemSettingImage(payload) {
      this.deleteImageDialog = false;
      let response = await this.deleteSystemSettingImageRequest(payload);
      let index = this.systemsettingimages.findIndex((trans) => trans._id == response._id);
      this.systemsettingimages.splice(index, 1);
    },
    editSystemSetting() {
      this.systemsetting._id = this.initvalue._id;
      this.updateSystemSettingRequest(this.systemsetting);
      this.getSystemSettingsRequest();
      router.push('/systemsetting/list');
    },
    async editSystemSettingList() {
      this.showListSheet = false;
      this.list.systemsettinglistid = this.editlist._id;
      let response = await this.updateSystemSettingListRequest(this.list);
      let index = this.systemsettinglists.findIndex((x) => x._id == response._id);
      this.systemsettinglists.splice(index, 1, response);
    },
    editSystemSettingListSheet(item) {
      this.list = {};
      this.showListSheet = true;
      this.editlist = Object.assign({}, item);
    },
    editSystemSettingImageSheet(item) {
      this.image = {};
      this.showImageSheet = true;
      this.editimage = Object.assign({}, item);
    },
    async editSystemSettingImage() {
      this.showImageSheet = false;
      this.imagefile = null;
      this.image.systemsettingimageid = this.editimage._id;
      let response = await this.updateSystemSettingImageRequest(this.image);
      let index = this.systemsettingimages.findIndex((x) => x._id == response._id);
      this.systemsettingimages.splice(index, 1, response);
    },
    onImageFileChange(file) {
      if (!file) {return;}
      this.image.imagefile = file;
      this.image.imagefilename = file.name;
    },
    updateChangedValue(value, field){
      this.systemsetting[field] = value;
    },
    updateChangedImage(value, field){
      this.image[field] = value;
    }, 
    updateChangedList(value, field){
      this.list[field] = value;
    },    
  },
  computed: {
    ...mapState('SystemSetting', ['isReceiving'])
  },
  created () {
    this.initvalue = this.$route.params;
    this.systemsettinglists = this.initvalue.settinglists;
    if(!this.initvalue._id) this.$router.push({ name: 'SystemSettingList' });
  },
}
</script>

<style src="./Edit.scss" lang="scss"></style>
